
<!-- spacer -->
<div *ngIf="compact" style="width: 4.93rem;" class="hidden lg:block"></div>
<!-- / spacer -->

<div [class.compact]="compact" [class.small]="small" class="admin-menu fixed lg:sticky h-screen top-0" style="z-index: 6;">

  <div #backdrop (click)="onMenuBackdrop($event)" class="menu-backdrop hidden"></div>
  
  <div #menu id="app-admin-menu" class="surface-section hidden lg:block flex-shrink-0 h-full lg:static left-0 top-0 z-2 border-right-1 surface-border select-none" >
    <div class="flex flex-column" style="height: 100dvh;">
        <div class="flex align-items-center  justify-content-center flex-shrink-0" style="height:4.2rem;">
          <img src="assets/images/logos/Logo-notext-color.svg" style="height: 32px;" alt="Lektory logo">
        </div>
        <div class="px-4">
          <app-selectable-orgs-dropdown></app-selectable-orgs-dropdown>
        </div>
        <div class="overflow-y-auto">
            <ul class="list-none p-3 m-0">
              <ng-container *ngFor="let item of adminMenuItems">
                <li>
                  <!-- <div pRipple class="p-3 flex align-items-center justify-content-between text-600 cursor-pointer" pStyleClass="@next" enterClass="hidden" enterActiveClass="slidedown" leaveToClass="hidden" leaveActiveClass="slideup">
                    <span class="font-medium">{{ section.title }}</span>
                    <i class="pi pi-chevron-down"></i>
                  </div>
                    <ul class="list-none p-0 m-0 overflow-hidden">
                        <ng-container *ngFor="let item of section.subItems">
                          <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{item:item}"></ng-container>
                        </ng-container>
                    </ul> -->
                  <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{item:item}"></ng-container>
                </li>
              </ng-container>
            </ul>
        </div>
        <div class="mt-auto">
            <hr class="mb-2 mx-3 border-top-1 border-none surface-border" />
            <app-user-menu-item
              pRipple
              class="user-menu-item  flex align-items-center cursor-pointer text-700 border-2 border-transparent hover:border-300 transition-duration-150 transition-colors"
              style="border-radius: 12px">
            </app-user-menu-item>

        </div>
    </div>
  </div>
</div>



<ng-template #menuItem let-item="item">
  <li>
    <a (click)="onMenuItem(item)" pRipple [routerLink]="item.path ? [item.path] : null" routerLinkActive="active" class="router-link no-underline flex align-items-center border-round cursor-pointer text-700 hover:surface-100 transition-duration-150 transition-colors"
      >
        <i class="{{ item.icon }} router-link-icon"></i>
        <span class="font-medium router-link-title">{{ item.title | translate }}</span>
        <i *ngIf="item.subItems" class="pi pi-chevron-down ml-auto"></i>
    </a>
    <ul *ngIf="item.subItems" class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
      <ng-container *ngFor="let subItem of item.subItems">
        <ng-container [ngTemplateOutlet]="menuItem" [ngTemplateOutletContext]="{item:subItem}"></ng-container>
      </ng-container>
    </ul>
  </li>
</ng-template>

@if ([DeviceSize.SM, DeviceSize.MD].includes((sysService.deviceSize$ | async)!)) {
  @if (quickMobileMenuItems.length) {
    <app-modal-footer-menu [items]="quickMobileMenuItems" class="quick-mobile-menu" [selectorToHandleSpacer]="MODAL_FOOTER_MENU_SPACER_CONTAINER_SELECTOR"></app-modal-footer-menu>
  }
}